import {IconButton} from '@wandb/components';
// @todo: Migrate to 'TagGroup' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tag} from '@wandb/weave/components/Tag';
import React, {useState} from 'react';
import {twMerge} from 'tailwind-merge';

import {maybePluralize} from '../../../util/uihelpers';

type MultiMetricPanelsListItemProps = {
  regex: string;
  metrics: string[];
};

export const MultiMetricPanelsListItem = ({
  regex,
  metrics,
}: MultiMetricPanelsListItemProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div className="rounded-md bg-moon-100 px-16 py-12">
      <div className="flex items-start justify-between gap-12">
        <span
          className={twMerge('flex-1', isExpanded ? 'break-all' : 'truncate')}>
          {regex}
        </span>
        <div className="flex gap-8 items-center flex-shrink-0">
          {/* TODO: switch to Counter once display text is supported */}
          <Tag label={maybePluralize(metrics.length, 'metric')} color="moon" />
          <IconButton
            aria-label={isExpanded ? 'Hide metrics' : 'Show metrics'}
            icon={isExpanded ? 'chevron-up' : 'chevron-down'}
            variant="ghost"
            size="sm"
            onPress={() => setIsExpanded(prev => !prev)}
          />
        </div>
      </div>
      {isExpanded && (
        <ul className="mt-8 list-disc ml-22 break-all">
          {metrics.map(metric => (
            <li key={metric}>{metric}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
